/**
 * pf
 */
export default
    {
        path: "/pf",
        component: () => import('@/views/MainContent/MainContent'),
        children: [
            {
                path: '/workspace/platform',
                name: '/workspace/platform',
                component: () => import('@/views/pf/HomePage'),
                meta: {
                    keepAlive: false,
                    title:'平台工作台'
                }
            },
            {
                path: '/workspace/noticeManage',
                name: '/workspace/noticeManage',
                component: () => import('@/views/pf/notice/NoticeList.vue'),
                meta: {
                    keepAlive: false,
                    title:'公告管理'
                }
            },
            {
                path: 'goods/examine',
                name: 'goods/examine',
                component: () => import('@/views/pf/examine/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'商品审核'
                }
            },
            {
                path: 'goods/mainSku',
                name: 'goods/mainSku',
                component: () => import('@/views/pf/mainSku/index.vue'),
                meta: {
                    keepAlive: true,
                    title:'仓库SKU'
                }
            },
            {
                path: 'goods/pfSku',
                name: 'goods/pfSku',
                component: () => import('@/views/pf/pfSku/index.vue'),
                meta: {
                    keepAlive: true,
                    title:'平台SKU'
                }
            },
            {
                path: 'transport/receive',
                name: 'transport/receive',
                component: () => import('@/views/pf/transport/receive/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'采购收货'
                }
            },
            {
                path: 'transport/deliver',
                name: 'transport/deliver',
                component: () => import('@/views/pf/transport/deliver/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'采购发货'
                }
            },
            {
                path: 'transport/detail',
                name: 'transport/detail',
                component: () => import('@/views/pf/transport/receive/detail.vue'),
                meta: {
                    keepAlive: true,
                    title:'查看采购单'
                }
            },
            {
                path: 'order/list',
                name: 'order/list',
                component: () => import('@/views/pf/order/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'销售订单'
                }
            },
            {
                path: 'order/refund',
                name: 'order/refund',
                component: () => import('@/views/pf/order/return/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'退货单'
                }
            },
            {
                path: 'business/list',
                name: 'business/list',
                component: () => import('@/views/pf/business/list.vue'),
                meta: {
                    keepAlive: true,
                    title:'商家列表'
                }
            },
            {
                path: 'purchase/list',
                name: 'purchase/list',
                component: () => import('@/views/pf/purchase/list.vue'),
                meta: {
                    keepAlive: true,
                    title:'采购单审核'
                }
            },
            {
                path: 'purchase/detail',
                name: 'purchase/detail',
                component: () => import('@/views/pf/purchase/detail.vue'),
                meta: {
                    keepAlive: true,
                    title:'采购单详情'
                }
            },
            {
                path: 'purchase/private-order',
                name: 'purchase/private-order',
                component: () => import('@/views/pf/purchase/private-order/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'私发单管理'
                }
            },
            {
                path: 'user/roleList',
                name: 'user/roleList',
                component: () => import('@/views/pf/role/List.vue'),
                meta: {
                    keepAlive: true,
                    title:'角色管理'
                }
            },
            {
                path: 'user/list',
                name: 'user/list',
                component: () => import('@/views/pf/user/List.vue'),
                meta: {
                    keepAlive: true,
                    title:'人员列表'
                }
            },
            {
                path: 'stock/warehouseList',
                name: 'stock/warehouseList',
                component: () => import('@/views/pf/warehouse/List.vue'),
                meta: {
                    keepAlive: true,
                    title:'仓库列表'
                }
            },
            {
                path: 'stock/list',
                name: 'stock/list',
                component: () => import('@/views/pf/warehouse/WarehouseGoods.vue'),
                meta: {
                    keepAlive: true,
                    title:'库存列表'
                }
            },
            {
                path: 'setting/rule-charging',
                name: 'setting/rule-charging',
                component: () => import('@/views/pf/rulecharging/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'商家扣费规则配置'
                }
            },
            {
                path: 'setting/rule-shop',
                name: 'setting/rule-shop',
                component: () => import('@/views/pf/ruleshop/RuleShop.vue'),
                meta: {
                    keepAlive: true,
                    title:'商家账单规则配置'
                }
            },
            {
                path: 'setting/rule-warehouse',
                name: 'setting/rule-warehouse',
                component: () => import('@/views/pf/rulewarehouse/RuleWarehouse.vue'),
                meta: {
                    keepAlive: true,
                    title:'仓库账单规则配置'
                }
            },
            {
                path: 'setting/rule-location',
                name: 'setting/rule-location',
                component: () => import('@/views/pf/locationrules/List.vue'),
                meta: {
                    keepAlive: true,
                    title:'商户库位账单配置'
                }
            },
            {
                path: 'acct/shop',
                name: 'acct/shop',
                component: () => import('@/views/pf/acct/shop/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'商户账单对账'
                }
            },
            {
                path: 'acct/bill-detail',
                name: 'acctbill-detail',
                component: () => import('@/views/pf/acct/shop/bill-detail.vue'),
                meta: {
                    keepAlive: false,
                    title:'账单详情'
                }
            },
            {
                path: 'acct/warehouse',
                name: 'acct/warehouse',
                component: () => import('@/views/pf/acct/warehouse/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'仓库账单对账'
                }
            },
            {
                path: 'acct/other',
                name: 'acct/other',
                component: () => import('@/views/pf/acct/other/tags.vue'),
                meta: {
                    keepAlive: true,
                    title:'其他费用'
                }
            },
            {
                path: 'acct/charge-list',
                name: 'chargeList',
                component: () => import('@/views/pf/acct/charge-list'),
                meta: {
                    keepAlive: true,
                    title:'充值管理'
                }
            },
            {
                path: 'acct/bill-flow',
                name: 'billFlow',
                component: () => import('@/views/pf/acct/bill-flow'),
                meta: {
                    keepAlive: true,
                    title:'收支明细'
                }
            },
            {
                path: 'acct/freeze-log',
                name: 'freezeLog',
                component: () => import('@/views/pf/acct/freeze-log'),
                meta: {
                    keepAlive: true,
                    title:'冻结明细'
                }
            },
            {
                path: 'finance/shop',
                name: 'finance/shop',
                component: () => import('@/views/pf/finance/List.vue'),
                meta: {
                    keepAlive: false,
                    title:'商户账单'
                }
            },
            {
                path: 'finance/warehouse',
                name: 'finance/warehouse',
                component: () => import('@/views/pf/finance/warehouse.vue'),
                meta: {
                    keepAlive: false,
                    title:'仓库账单'
                }
            },
            {
                path: 'system/operationLog',
                name: 'system/operationLog',
                component: () => import('@/views/pf/operationLog/List.vue'),
                meta: {
                    keepAlive: true,
                    title:'操作日志'
                }
            },
            {
                path: 'system/alert',
                name: 'system/alert',
                component: () => import('@/views/pf/alert/List.vue'),
                meta: {
                    keepAlive: true,
                    title:'系统告警'
                }
            },
            {
                path: 'system/menu',
                name: 'system/menu',
                component: () => import('@/views/pf/menu/List.vue'),
                meta: {
                    keepAlive: true,
                    title:'菜单管理'
                }
            },
            {
                path: 'system/sysLog',
                name: 'system/sysLog',
                component: () => import('@/views/pf/sysLog/List.vue'),
                meta: {
                    keepAlive: false,
                    title:'系统日志'
                }
            },
            {
                path: 'system/repair-charges',
                name: 'system/repair-charges',
                component: () => import('@/views/pf/repair/RepairMissedCharges.vue'),
                meta: {
                    keepAlive: false,
                    title:'漏扣修复'
                }
            }

        ]

    }



// WEBPACK FOOTER //
// ./src/router/pf.js